import { ButtonTheme } from 'components/Button';
import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { Menu } from 'components/Menu';
import { SeparatorHorizontal } from 'components/SeparatorHorizontal';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import React from 'react';
import { selectAseSetupLibrarySection } from 'store/remote/selectors';

type Props = {
  id: number;
  totalCount: number;
  selectedCount: number;
  onSelectAll: (id: number) => void;
  onDeselectAll: (id: number) => void;
  isFirstSection: boolean;
};

export const SectionListItem: React.FC<Props> = React.memo(
  ({
    id,
    onSelectAll,
    onDeselectAll,
    totalCount,
    selectedCount,
    isFirstSection,
  }) => {
    const section = useSelector((state) =>
      selectAseSetupLibrarySection(state, id),
    )!;
    return (
      <Card
        borderRadiusTop
        borderRadiusBottom={false}
        style={
          !isFirstSection
            ? { marginTop: theme.paddingHorizontalHalf }
            : undefined
        }
        separator={null}
      >
        <CardRow
          contentStyle={{
            paddingTop: 0,
            paddingBottom: 0,
          }}
          childrenStyle={{
            flexDirection: 'row',
            alignItems: 'center',
          }}
          showMenuOnPress
          hideMenuButton
          menuOptions={[
            { text: 'Select All Questions', onPress: () => onSelectAll(id) },
            {
              text: 'Deselect All Questions',
              onPress: () => onDeselectAll(id),
            },
          ]}
        >
          <Txt style={{ flex: 1, marginRight: theme.padding }}>
            {section.name}
          </Txt>
          <Menu
            buttonConfig={{
              text: `${selectedCount}/${totalCount}`,
              textSize: 'small',
              textWeight: 'regular',
              buttonTheme: ButtonTheme.themeless,
              backgroundColor: '#f1f1f1',
              textStyle: { minWidth: 50, textAlign: 'center' },
            }}
            options={[
              { text: 'Select All Questions', onPress: () => onSelectAll(id) },
              {
                text: 'Deselect All Questions',
                onPress: () => onDeselectAll(id),
              },
            ]}
          />
        </CardRow>
        <SeparatorHorizontal />
      </Card>
    );
  },
);
